"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getIsoLocalesFromFields = exports.getField = void 0;
const internationalization_1 = require("../internationalization");
// TODO: create FieldBase type to extend all Field types
const getField = (fields, locale) => {
    return fields?.find((field) => field.locale === locale) || fields?.[0];
};
exports.getField = getField;
const getIsoLocalesFromFields = (fieldLocales, country) => {
    return fieldLocales.map((locale) => (0, internationalization_1.getIsoLocaleFromCountry)(country, locale));
};
exports.getIsoLocalesFromFields = getIsoLocalesFromFields;
